import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const cancelRejectService = {
    getAllCancelReject,
    getCancelReject,
};

const MODULE = {
    CANCEL_REJECT: 'appointment-cancel-rejects',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllCancelReject(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            is_active: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.CANCEL_REJECT}`, requestOptions)
}

export function getCancelReject(id) {
    return apiHelper(API_URL).get(`/${MODULE.CANCEL_REJECT}/${id}`)
}

